import { render, staticRenderFns } from "./NCLDMathScienceCollaborative2022.vue?vue&type=template&id=20969d1a&scoped=true"
import script from "./NCLDMathScienceCollaborative2022.vue?vue&type=script&lang=js"
export * from "./NCLDMathScienceCollaborative2022.vue?vue&type=script&lang=js"
import style0 from "./NCLDMathScienceCollaborative2022.vue?vue&type=style&index=0&id=20969d1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20969d1a",
  null
  
)

export default component.exports